import { useChurchStore } from "features/churches";
import { useParams } from "react-router-dom";
import { useMessages } from "../api";
import { ChatPanel, InboxesPanel, MessageList } from "../components";
import { useStoredMessagesStore } from "../store";

export const Inboxes = () => {
  const { id } = useParams();
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const storedMessages = useStoredMessagesStore(state => state.storedMessages);
  const storeMessages = useStoredMessagesStore(state => state.storeMessages);
  const inboxQuery = useMessages({
    churchId: selectedChurch?.id,
    filters: ["filters[message_type]=RECEIVED", "sort[created_at]=DESC"]
  });

  if (id) {
    storeMessages(inboxQuery?.data?.result);

    return (
      <>
        <MessageList title="Inbox" messages={storedMessages} />
        <ChatPanel />
      </>
    );
  }

  return <InboxesPanel />;
};
